import { render, staticRenderFns } from "./field-edit.vue?vue&type=template&id=12e3037a&scoped=true&"
import script from "./field-edit.vue?vue&type=script&lang=ts&"
export * from "./field-edit.vue?vue&type=script&lang=ts&"
import style0 from "./field-edit.vue?vue&type=style&index=0&id=12e3037a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3037a",
  null
  
)

export default component.exports